import type { StyleLayer } from './utils/types'

export const layers_roads_all: StyleLayer[] = [
  {
    id: 'roadclassification-nomainstreet copy',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      [
        'residential',
        'living_street',
        'bicycle_road',
        'pedestrian',
        'unclassified',
        'residential_priority_road',
        'unspecified_road',
        'service_road',
        'service_alley',
        'service_driveway',
        'service_emergency_access',
        'service_uncategorized',
        'service_parking_aisle',
      ],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': [
        'match',
        ['get', 'road'],
        ['residential'],
        '#a2c9f6',
        ['living_street', 'bicycle_road', 'pedestrian'],
        '#447be9',
        ['unclassified', 'residential_priority_road', 'unspecified_road'],
        '#ffdb70',
        [
          'service_alley',
          'service_uncategorized',
          'service_driveway',
          'service_emergency_access',
          'service_parking_aisle',
          'service_road',
        ],
        '#96e4b4',
        'rgba(213, 26, 26, 0.75)',
      ],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        10,
        [
          'case',
          [
            'match',
            ['get', 'road'],
            ['residential_priority_road', 'unclassified', 'living_street'],
            true,
            false,
          ],
          1,
          [
            'match',
            ['get', 'road'],
            [
              'residential',
              'living_street',
              'cycleway',
              'footway_sidewalk',
              'pedestrian',
              'bicycle_road',
              'service_road',
              'service_uncategorized',
              'unspecified_road',
              'service_alley',
              'service_driveway',
              'service_emergency_access',
              'service_parking_aisle',
            ],
            true,
            false,
          ],
          0.5,
          0.8,
        ],
        13,
        [
          'case',
          [
            'match',
            ['get', 'road'],
            ['residential_priority_road', 'unclassified', 'living_street'],
            true,
            false,
          ],
          2,
          [
            'match',
            ['get', 'road'],
            [
              'residential',
              'living_street',
              'cycleway',
              'footway_sidewalk',
              'pedestrian',
              'bicycle_road',
              'unspecified_road',
              'service_alley',
              'service_uncategorized',
              'service_driveway',
              'service_emergency_access',
              'service_parking_aisle',
            ],
            true,
            false,
          ],
          1,
          0.8,
        ],
        16,
        [
          'case',
          [
            'match',
            ['get', 'road'],
            ['residential_priority_road', 'unclassified', 'living_street'],
            true,
            false,
          ],
          4,
          [
            'match',
            ['get', 'road'],
            [
              'residential',
              'living_street',
              'cycleway',
              'footway_sidewalk',
              'pedestrian',
              'bicycle_road',
              'unspecified_road',
              'service_alley',
              'service_uncategorized',
              'service_driveway',
              'service_emergency_access',
              'service_parking_aisle',
            ],
            true,
            false,
          ],
          2,
          0.8,
        ],
      ],
    },
  },
  {
    id: 'roadclassification_mainstreets copy 1',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['primary', 'primary_link', 'secondary', 'secondary_link', 'tertiary', 'tertiary_link'],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': '#f6e7ac',
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          3,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          2,
          0.8,
        ],
        14,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          8,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          7,
          0.8,
        ],
        16,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          24,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          16,
          0.8,
        ],
      ],
    },
  },
  {
    id: 'roadclassification_motortrunk copy 1',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['trunk', 'motorway_link', 'motorway', 'trunk_link'],
      true,
      false,
    ],
    minzoom: 10,
    paint: {
      'line-color': '#828282',
      'line-width': ['interpolate', ['linear'], ['zoom'], 11, 1, 14, 1.5, 16, 2],
    },
  },
  {
    id: 'hitarea-roadclassification-sidepath copy',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['path', 'track', 'bridleway', 'footway', 'cycleway'],
      false,
      true,
    ],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
  {
    id: 'roads-onewaybikeyes-pattern-all',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'oneway_bicycle'], ['no'], true, false],
      [
        'match',
        ['get', 'road'],
        [
          'residential',
          'living_street',
          'bicycle_road',
          'pedestrian',
          'unclassified',
          'residential_priority_road',
          'unspecified_road',
          'service_road',
          'service_alley',
          'service_driveway',
          'service_emergency_access',
          'service_uncategorized',
          'service_parking_aisle',
        ],
        true,
        false,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
      'line-miter-limit': 0,
    },
    paint: {
      'line-opacity': 0.8,
      'line-pattern': 'pattern-oneway-bicycle',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
  {
    id: 'roads-oneway-pattern-all',
    type: 'line',
    filter: [
      'all',
      ['has', 'oneway'],
      ['match', ['get', 'oneway'], ['yes', 'implicit_yes'], true, false],
      [
        'match',
        ['get', 'road'],
        [
          'residential',
          'living_street',
          'bicycle_road',
          'pedestrian',
          'unclassified',
          'residential_priority_road',
          'unspecified_road',
          'service_road',
          'service_alley',
          'service_uncategorized',
          'service_driveway',
          'service_emergency_access',
          'service_parking_aisle',
        ],
        true,
        false,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
    },
    paint: {
      'line-opacity': 0.7,
      'line-pattern': 'pattern-oneway',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
]
